export const en = {
    month: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ],
    days: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ],
    time: 'Time',
    moment: { 
        week: {
            dow: 0, 
            doy: 6
        }
    },
    actions: {
        close: 'Close'
    }
}